import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import canva from '../assets/canva.webp';
import iphone from '../assets/iphone12.svg';
import profile from '../assets/profile.png';
import logo from '../assets/logo.png';
import al2 from '../assets/al2.png';
import profile1 from '../assets/profile1.png';
import facebook from '../assets/facebook.webp';
import tiktok from '../assets/tiktok.webp';
import instagram from '../assets/instagram.webp';
import video from '../assets/video.mov'
import smiley from '../assets/smiley.png'

import audit from '../assets/services/audit.jpg'
import basic from '../assets/services/basic.jpg'
import coaching from '../assets/services/coaching.jpg'
import com from '../assets/services/com.jpg'
import complet from '../assets/services/complet.jpg'
import confort from '../assets/services/confort.jpg'
import identite from '../assets/services/identite.jpg'
import insta from '../assets/services/insta.jpg'

const images = {
  email,
  mobile,
  profile,
  profile1,
  logo,
  canva,
  iphone,
  al2,
  facebook,
  tiktok,
  instagram,
  video,
  smiley,
  audit,
  basic,
  coaching,
  com,
  complet,
  confort,
  identite,
  insta
};

export default images;